module.exports = __webpack_public_path__ + "static/media/faqBalance-es-fa.00f4ff2f.vtt";